export const getMediaObjectKey = (media) => {
    if (!media)
        return '';
    return [media.account.id, media.filename].join('/');
};
